<script setup lang="ts">
import LinkSlot from "@/components/LinkSlot.vue";
import { useGrowthBookFeatures } from "@/composables/growthbook";

const emit = defineEmits<{
    (on: "amsGetGuaranteedQuotes"): void
}>();

const { redesign_lg_indicative_results202605 } = useGrowthBookFeatures();

// eslint-disable-next-line vue/max-len
const bannerText = "Indicative quotes give you an estimate. Guaranteed quotes confirm the actual income a provider will offer you. Guaranteed quotes are valid for a specific period of time.";
</script>

<template>
    <div
        v-if="redesign_lg_indicative_results202605"
        class="row ind-sum-box indicative-banner"
    >
        <div class="col-md-12 text-center">
            <b class="p-2">These are indicative quotes based on the details you've provided to Legal &amp; General.</b>
            <br><br>
            <LinkSlot
                :link-text="'What is an indicative quote?'"
            >
                <br><br>
                <p>{{ bannerText }}</p>
            </LinkSlot>
            <p class="desktop-only-text">
                {{ bannerText }}
            </p>
            <br><br>
            <p>
                Our panel providers need a little more information to give you guaranteed quotes.
            </p>
            <br>
            <button
                id="get_your_guaranteed_quotes_button"
                class="btn more_info btn-info indicative-cta"
                data-toggle="modal"
                data-target="ams-handoff-questions-modal"
                type="button"
                @click="emit('amsGetGuaranteedQuotes')"
            >
                Get your guaranteed quotes
            </button>
        </div>
    </div>
    <div
        v-else
        class="row ind-sum-box"
    >
        <div class="col-md-12 text-center">
            <p /><b class="p-2">The quotes shown below are indicative and based on the information you provided to Legal &amp; General.</b><p>
                Should you wish to make an adjustment to the details provided please use the 4 options below or click the 'More Options' button.<br>If you would like to make further changes please
                <router-link to="/">
                    click here
                </router-link>.
            </p><p>If you would like to view guaranteed quotes please click the 'Click to get guaranteed quotes' buttons below.</p>
        </div>
    </div>
</template>

<style scoped>
.indicative-banner {
    margin: 0 0 1rem;
    padding: 0.8rem 0.7rem 1rem;
    border-radius: 8px;
    background: #d9edf9;
}

.indicative-banner p {
    margin-bottom: 0;
}

/* deep select .link-button*/
:deep(.link-button) {
    display: none;
}

.desktop-only-text {
    display: block;
}

.indicative-cta {
    border-radius: 999px;
    min-width: 240px;
    font-weight: 700;
}

@media (max-width: 768px) {
    :deep(.link-button) {
        display: inline-block;
    }

    .desktop-only-text {
        display: none;
    }
}

@media (max-width: 991.98px) {
    .indicative-banner {
        margin-left: 0;
        margin-right: 0;
        padding: 0.95rem 0.75rem 1.1rem;
    }

    .indicative-cta {
        width: 100%;
        min-width: 0;
    }
}
</style>
